require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./context"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./context"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./context")) : factory(root["./utils"], root["./context"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__24__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[50],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _context = __webpack_require__(24);

__webpack_require__(447);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// Track the instance could such that we only are applying the class to the body once.
var instanceCount = 0;
var highContrast = false;

function detectHighContrast() {
  var oDiv = document.createElement('div');
  oDiv.className = 'ba-common-hcDetect';
  var oBody = document.body;
  oBody.appendChild(oDiv);
  var styles = window.getComputedStyle(oDiv);
  var oValues = {
    borderTopColor: styles.borderTopColor,
    borderLeftColor: styles.borderLeftColor,
    backgroundImage: styles.backgroundImage
  };

  if (oValues.borderTopColor === oValues.borderLeftColor || oValues.backgroundImage && oValues.backgroundImage.indexOf('data:image') === -1) {
    highContrast = true;
  }

  oDiv.parentNode.removeChild(oDiv);
}

var HighContrastDetect = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(HighContrastDetect, _Component);

  function HighContrastDetect() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = HighContrastDetect.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (instanceCount === 0 && document) {
      detectHighContrast();

      if (highContrast) {
        document.body.classList.add('ba--highContrast');
      }
    }

    instanceCount += 1;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    instanceCount -= 1;

    if (instanceCount === 0 && document && highContrast) {
      document.body.classList.remove('ba--highContrast');
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_context.ContextProvider, {
      highContrast: highContrast
    }, _react.Children.only(this.props.children));
  };

  return HighContrastDetect;
}(_react.Component);

exports["default"] = HighContrastDetect;
(0, _defineProperty2["default"])(HighContrastDetect, "propTypes", {
  children: _propTypes["default"].node.isRequired
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(445);


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Root = _interopRequireDefault(__webpack_require__(446));

exports["default"] = _Root["default"];
exports.Root = _Root["default"];

var _HighContrastDetect = _interopRequireDefault(__webpack_require__(120));

exports.HighContrastDetect = _HighContrastDetect["default"];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _HighContrastDetect = _interopRequireDefault(__webpack_require__(120));

__webpack_require__(449);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// TODO do we want to bring in style ?
// import './styles/index.scss';
var Root = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Root, _Component);

  function Root() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Root.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className"]);
    return /*#__PURE__*/_react["default"].createElement(_HighContrastDetect["default"], null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
      className: (0, _utils.classnames)('ba-common-root', className)
    })));
  };

  return Root;
}(_react.Component);

exports["default"] = Root;
(0, _defineProperty2["default"])(Root, "propTypes", {
  className: _propTypes["default"].string
});

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(448);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-hcDetect{position:absolute;top:-1000px;height:5px;width:5px;border:1px solid;border-color:#00f #008000;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=)}\n", ""]);

// exports


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(450);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-root{margin:0;padding:0;height:100%;width:100%;box-sizing:border-box;z-index:1}\n", ""]);

// exports


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[444,0]]]);
});